import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatusAddPayload, StatusEditPayload } from './status.interface';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class StatusService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listDTUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus.listDT;

    private storeURL =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus.store;

    private deleteUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus
            .listPublic;

    private updateUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus.update;

    private clearCacheUrl = this.basePath + environment.interop.deps.nomenclatoare.cerereStatus.clearCache;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus
            .active;
    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.cerereStatus
            .public;
    private getRankListURL = this.basePath + environment.interop.deps.nomenclatoare.cerereStatus.rankList;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getStatusDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    storeStatus(data: StatusAddPayload) {
        return this.http.post(this.storeURL, data, this.httpOptions);
    }

    getActiveStatus() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getPublicStatus() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    updateStatus(updateStatus: StatusEditPayload) {
        return this.http.put(this.updateUrl, updateStatus, this.httpOptions);
    }

    deleteStatus(sectionId: number) {
        return this.http.delete(this.deleteUrl + sectionId);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getRanksList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getRankListURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                        slug: item.slug,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get ranks:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
